// test387
(387 && 0);
